export default __webpack_public_path__ + "static/media/VIVIgas_logo_orizz.0b5fc677.png";